module.exports = __webpack_public_path__ + "static/media/trash-full.9115756f.svg";